const RAW_BASE_URL = process.env.REACT_APP_BASE_URL || "https://cdn24.wsiz.edu.pl/api";

export interface ApiEvent {
  id: string;
  source_event_id: string;
  name: string;
  description: string;
  scheduled_start_time: string;
  scheduled_end_time: string;
  user_count: number;
  location: string;
  event_mode: "online" | "offline" | "hybrid" | string;
  is_new: boolean;
  created_at: string;
}

interface ApiEventsResponse {
  collected_at: string;
  events_count: number;
  events: ApiEvent[];
}

export async function fetchUpcomingEvents(): Promise<ApiEvent[]> {
  const url = `${RAW_BASE_URL}/public/events/upcoming`;

  const res = await fetch(url, {
    method: "GET",
    headers: { accept: "application/json" },
  });

  if (!res.ok) {
    throw new Error(`Events API error: ${res.status} ${res.statusText}`);
  }

  const data: ApiEventsResponse = await res.json();
  return data.events ?? [];
}
